import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "./_utils";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;

export function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        className={cn(
          // Glass: a popover is a transient overlay floating over the field.
          "z-50 w-72 rounded-[var(--radius-card)] border border-[var(--glass-border)] " +
            "bg-[var(--glass-bg)] " +
            "[-webkit-backdrop-filter:blur(var(--glass-blur))_saturate(1.15)] " +
            "[backdrop-filter:blur(var(--glass-blur))_saturate(1.15)] " +
            "p-lg text-text-primary shadow-[var(--shadow-overlay)] outline-none",
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}

/**
 * Popover built on Radix Popover (outside-click + Escape to close).
 *
 * @example
 * <Popover>
 *   <PopoverTrigger asChild><Button>More</Button></PopoverTrigger>
 *   <PopoverContent>Contents here</PopoverContent>
 * </Popover>
 */
